export interface AdminPageIntroItem {
  title: string;
  url?: string;
}

export interface AdminPageIntroMetaItem {
  label: string;
  value: string;
}

export interface AdminPageIntroConfig {
  eyebrow: string;
  title: string;
  summary: string;
  breadcrumbs: AdminPageIntroItem[];
  meta?: AdminPageIntroMetaItem[];
}

const AdminPageIntro = ({ eyebrow, title, summary, meta }: AdminPageIntroConfig): JSX.Element => {
  return (
    <section className="app-list-hero">
      <div>
        <p className="app-list-hero__eyebrow">{eyebrow}</p>
        <h1 className="app-list-hero__title">{title}</h1>
        <p className="app-list-hero__summary">{summary}</p>
      </div>
      {!!meta?.length && (
        <div className="app-list-hero__meta">
          {meta.map((item) => (
            <div className="app-list-hero__stat" key={`${item.label}-${item.value}`}>
              <span className="app-list-hero__stat-value">{item.value}</span>
              <span className="app-list-hero__stat-label">{item.label}</span>
            </div>
          ))}
        </div>
      )}
    </section>
  );
};

export default AdminPageIntro;
